import { type AnalyticsBrowser } from '@segment/analytics-next';
import { createContext, type MutableRefObject } from 'react';

export type AnalyticsContextValues = {
  analyticsRef: MutableRefObject<AnalyticsBrowser | undefined>;
  globalPropsRef: MutableRefObject<object>;
};

const defaultAnalyticsContext: AnalyticsContextValues = {
  analyticsRef: {
    current: undefined,
  },
  globalPropsRef: {
    current: {},
  },
};

export const AnalyticsContext = createContext<AnalyticsContextValues>(defaultAnalyticsContext);
